import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { Loader2 } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Typography } from '@/components/ui/typography'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { GreybullUsersTab } from '@/components/custom/admin/greybull-users-tab'
import { PortcoAccessTab } from '@/components/custom/admin/portco-access-tab'
import { useAdminUsers } from '@/hooks/use-admin'

export const Route = createFileRoute('/_authenticated/admin/users')({
  component: UserManagementPage,
})

function UserManagementPage() {
  const [activeTab, setActiveTab] = useState('greybull')
  const users = useAdminUsers()

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-5 overflow-y-auto pb-6 pr-4 md:pr-8 [overflow-anchor:none]">
      <PageHeader title="User Management" useSeparator={false} />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="greybull">Greybull team</TabsTrigger>
          <TabsTrigger value="portco">PortCo users</TabsTrigger>
        </TabsList>

        <TabsContent value="greybull" className="mt-4">
          {users.isLoading ? (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="h-5 w-5 animate-spin text-primary/20" />
            </div>
          ) : users.isError ? (
            <div className="flex items-center justify-center py-16">
              <Typography variant="muted">Failed to load users.</Typography>
            </div>
          ) : (
            <GreybullUsersTab users={users.data ?? []} />
          )}
        </TabsContent>

        <TabsContent value="portco" className="mt-4">
          {users.isLoading ? (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="h-5 w-5 animate-spin text-primary/20" />
            </div>
          ) : users.isError ? (
            <div className="flex items-center justify-center py-16">
              <Typography variant="muted">Failed to load users.</Typography>
            </div>
          ) : (
            <PortcoAccessTab users={users.data ?? []} />
          )}
        </TabsContent>
      </Tabs>
    </div>
  )
}
